// extracted by mini-css-extract-plugin
module.exports = {"root":"Cell_root__1lCE0","content":"Cell_content__2IFjj"};